// This plugin injects a small script into index.html that defines window.require
// in environments (like Vite) that don't ship a loader.js-style AMD runtime.
//
// ember-repl's GJS evaluator falls back to window.require(moduleName) for
// modules that are not part of its built-in known-modules map and are not
// provided via the EvalImportMap/extraModules argument.
//
// The shim keeps things simple:
// - If window.require already exists, it does nothing.
// - Otherwise it creates window.__emberReplModuleRegistry (if needed) and
//   sets window.require to look up modules from there.
// - If requirejs (from loader.js) exists, it will delegate to that as a
//   fallback.
//
// This lets you do, for example, in your app code:
//
//   window.__emberReplModuleRegistry ||= {};
//   window.__emberReplModuleRegistry['some/module/name'] = SomeModule;
//
// and then ember-repl will be able to resolve `require('some/module/name')`.
export default function emberReplRequireShim() {
  return {
    name: 'ember-repl-require-shim',
    transformIndexHtml(html: string) {
      return {
        html,
        tags: [
          {
            tag: 'script',
            injectTo: 'head',
            children: `
              (function () {
                var existingRequire = window.require;
                var requirejs = window.requirejs;

                // If something (like loader.js) already defined window.require,
                // respect it and do nothing.
                if (typeof existingRequire === 'function') {
                  return;
                }

                var registry = window.__emberReplModuleRegistry = window.__emberReplModuleRegistry || {};

                window.require = function (moduleName) {
                  if (Object.prototype.hasOwnProperty.call(registry, moduleName)) {
                    return registry[moduleName];
                  }

                  if (typeof requirejs === 'function') {
                    return requirejs(moduleName);
                  }

                  throw new Error(
                    '[ember-repl] window.require("' + moduleName + '") was called, ' +
                    'but no module was found in window.__emberReplModuleRegistry and no global requirejs() is available. '
                  );
                };
              })();
            `
          }
        ]
      };
    }
  };
}
